import {inject, Injectable} from '@angular/core';
import {map, Observable, of} from 'rxjs';
import {AUTHENTICATION_SERVICE, AuthenticationService} from '../../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard {
  authenticationService = inject<AuthenticationService>(AUTHENTICATION_SERVICE);

  async canActivate(): Promise<Observable<boolean>> {
    if (this.authenticationService.userInfo) return of(true);

    return this.authenticationService.loadUserData()
      .pipe(map((data) => data != null));
  }
}
